<template>
    <img
        v-if="meta?.flagUrl"
        class="nationality-flag"
        :src="meta.flagUrl"
        :alt="meta.label"
        :title="meta.label"
        width="24"
        height="18"
        loading="lazy"
        decoding="async"
    />
</template>

<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { nationalityMeta } from '@/utils/nationality';

const props = defineProps({
    code: {
        type: String,
        default: null,
    },
});

const page = usePage();

const meta = computed(() => nationalityMeta(props.code, page.props.nationalityOptions ?? []));
</script>

<style scoped lang="scss">
.nationality-flag {
    display: inline-block;
    width: 1.5rem;
    height: 1.125rem;
    object-fit: cover;
    border-radius: 2px;
    border: 1px solid rgba(15, 23, 42, 0.12);
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
    flex-shrink: 0;
    vertical-align: middle;
}
</style>
